module.exports = __webpack_public_path__ + "img/graphmetrix-trinity-links-pdfs.9d9bc64b.jpg";